module.exports = __webpack_public_path__ + "318dda3b86852212148c38f3c4586b2d.png";